/**
 * Duct tape. Light, worth more than it looks, and the second junk item, which is what proves the
 * category is a directory rather than one file with a table in it.
 */

import type { JunkItem } from '@/sim/items/itemContract';

export const DUCT_TAPE_ROLL = {
  id: 'ductTapeRoll',
  kind: 'junk',
  label: 'Roll of duct tape',
  description: 'Holds two of anything together. Rated for temperatures nobody sees any more.',
  rarity: 'uncommon',
  weightKg: 0.25,
  stackLimit: 10,
  equip: null,
  scrapValue: 9,
} as const satisfies JunkItem;
